import {makeStyles} from "@material-ui/core";

export default function confOpcoesRecebimentoListaCss() {
    return makeStyles(theme => ({
        root: {
            marginTop: '10px',
            padding: '30px'
        },
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: '700px',
        },
    }));
}